
import { Component, Inject, OnInit } from '@angular/core';
import { DialogApprovedMessageComponent } from '../dialog-approved-message/dialog-approved-message.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogRejectMessageComponent } from '../dialog-reject-message/dialog-reject-message.component';

@Component({
  selector: 'app-asset-transfer-stepper',
  templateUrl: './asset-transfer-stepper.component.html',
  styleUrls: ['./asset-transfer-stepper.component.scss']
})
export class AssetTransferStepperComponent implements OnInit {
  completed = true;
  constructor(private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<AssetTransferStepperComponent>) { }
  ngOnInit(): void {

  }

  onClick() {
    this.dialogRef.close();
  }

  Approve() {
    const dialogRef = this.dialog.open(DialogApprovedMessageComponent, {
      width: '22%',
      position: { top: '50px' },
      disableClose: true,
    });
  }

  reject() {
    const dialogRef = this.dialog.open(DialogRejectMessageComponent, {
      width: '22%',
      position: { top: '50px' },
      disableClose: true,
    });
  }
}
